import type { HelpFile } from '../../types/help'
import { ApprovalPoliciesTestIds } from '../../../testids/ApprovalPoliciesTestIds'

export const approvalPoliciesHelp: HelpFile = {
  docPage: '/docs/governance/policies',
  texts: {
    [ApprovalPoliciesTestIds.approvalPoliciesList]:
      'Every approval policy — the rules that decide who must approve a request and in what order.',
    [ApprovalPoliciesTestIds.btnCreatePolicy]: null,
    [ApprovalPoliciesTestIds.colName]: null,
    [ApprovalPoliciesTestIds.colPolicyType]:
      'Request type the policy applies to: access profile, role, function group, or rule.',
    [ApprovalPoliciesTestIds.colPriority]:
      'Higher priority wins when multiple policies match the same request.',
    [ApprovalPoliciesTestIds.colConditions]:
      'Predicates a request must satisfy for the policy to apply.',
    [ApprovalPoliciesTestIds.colSteps]:
      'Approval steps in this policy — each step adds one round of approver decisions.',
    [ApprovalPoliciesTestIds.colStatus]:
      'Inactive policies are skipped during evaluation; new requests do not see them.',
  },
}
